import { render, staticRenderFns } from "./WPHeader.vue?vue&type=template&id=3c465de9&functional=true&"
import script from "./WPHeader.vue?vue&type=script&lang=js&"
export * from "./WPHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports